export enum ETreatmentPriority {
  High = 'ALTA',
  Low = 'BAIXA',
  Medium = 'MEDIA',
}
